/**
 * Created by JIA on 2020/4/9.
 */
import _ from "lodash";

import BaseSpeechService from "./BaseSpeechService";
import { AzureEnums, buildZeroReviewResult, buildZeroReviewResultForEn, reviewServiceTypeEnum, reviewServiceTypeEnum as serviceTypeEnum } from "./SpeechCommonHelper";
import { handleTextForAzure, handleAzureResult } from "./ReviewService/AzureReviewService";
import { handleSingSoundResult, handleTextForSingSound } from "./ReviewService/SingSoundReviewService";
import { handleTextForXunFei, handleXunfeiResult } from "./ReviewService/XunFeiReviewService";
import Constants from "../../../config/Constants";

//endregion

const commonHandleResult = (internalInfoObj, response, resolve, reject) => {
    //do some convert for response since the native code return raw json back
    try {
        const isEnCase = (internalInfoObj.lang === Constants.SPEECH_LANG.en);
        const audioToShort = response && response.audioToShort;
        if (audioToShort) {
            let returnObjZ = isEnCase ? buildZeroReviewResultForEn(internalInfoObj.orgReferenceText, internalInfoObj.syllableArray) : buildZeroReviewResult(internalInfoObj.orgReferenceText, internalInfoObj.syllableArray);
            resolve(returnObjZ);
        } else {
            switch (internalInfoObj.reviewServiceType) {
                case serviceTypeEnum.Azure:
                    const jsonResult = JSON.parse(_.toString(response));
                    const azureResult = handleAzureResult(internalInfoObj, jsonResult);

                    if (azureResult && azureResult.shouldResolve) {
                        resolve(azureResult.result);
                    } else {
                        reject({ code: "error", message: azureResult.rejectMessage });
                    }
                    break;
                case serviceTypeEnum.XunFei:
                    //xunfei use xml parse lib is callback mode, so just pass in a callback fn for final
                    handleXunfeiResult(internalInfoObj, _.toString(response), xunFeiResult => {
                        if (xunFeiResult && xunFeiResult.shouldResolve) {
                            resolve(xunFeiResult.result);
                        } else {
                            reject({
                                code: "error",
                                message: xunFeiResult.rejectMessage,
                            });
                        }
                    });
                    break;
                case serviceTypeEnum.SingSound:
                    //
                    const jsonResultSingSound = JSON.parse(_.toString(response));
                    const singSoundResult = handleSingSoundResult(internalInfoObj, jsonResultSingSound);

                    if (singSoundResult && singSoundResult.shouldResolve) {
                        resolve(singSoundResult.result);
                    } else {
                        reject({ code: "error", message: singSoundResult.rejectMessage });
                    }
                    break;
                default:
                    resolve(response);
                    break;
            }
        }
    } catch (e) {
        reject(e);
    }
};

const setTextCommonFn = (internalObj, nativeSetReferenceText) => {
    if (internalObj.reviewServiceType === reviewServiceTypeEnum.XunFei) {
        handleTextForXunFei(internalObj, nativeSetReferenceText);
    } else if (internalObj.reviewServiceType === reviewServiceTypeEnum.SingSound) {
        handleTextForSingSound(internalObj, nativeSetReferenceText);
    } else if (internalObj.reviewServiceType === reviewServiceTypeEnum.Azure) {
        handleTextForAzure(internalObj, nativeSetReferenceText);
    }
};

const SpeechReview = {
    ...BaseSpeechService,
    init: config => {
        config.forReview = true;
        config.reviewServiceType = config.serviceType;
        config.customHandler = {
            setReferenceSyllables: setTextCommonFn,
            setReferenceText: setTextCommonFn,
            handleResult: commonHandleResult,
        };
        return BaseSpeechService.init(config);
    },
    initWithoutKey: config => {
        config.forReview = true;
        config.reviewServiceType = config.serviceType;
        config.customHandler = {
            setReferenceSyllables: setTextCommonFn,
            setReferenceText: setTextCommonFn,
            handleResult: commonHandleResult,
        };
        return BaseSpeechService.initWithoutKey(config);
    },
};

SpeechReview.propTypes = BaseSpeechService.propTypes;

export default SpeechReview;
